import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { ChangePasswordForm } from '@/features/delegate/components/ChangePasswordForm';
import { Card, CardContent } from '@/shared/components/ui';
import { PageTransition } from '@/shared/motion';
import { useAuthStore } from '@/shared/stores/authStore';

export const Route = createFileRoute('/user/change-password')({
  component: UserChangePasswordRoute,
});

function UserChangePasswordRoute() {
  const navigate = useNavigate();
  const mustChange = useAuthStore((s) => s.user?.mustChangePassword ?? false);
  return (
    <PageTransition className="mx-auto w-full max-w-md">
      <Card>
        <CardContent className="p-6">
          <ChangePasswordForm
            forced={mustChange}
            onSuccess={() => void navigate({ to: '/user' })}
          />
        </CardContent>
      </Card>
    </PageTransition>
  );
}
